/*
 * @Description:
 * @Author: fiveonelei
 * @Date: 2022-03-18 22:05:36
 * @FilePath: /vise/packages/app-share/src/composable/use-request-data-method/fetch-rec-feeds.ts
 */
import { useStore } from '@/store/index';
import useProvideUrlInfo from '@/composable/use-provide-url-info';
import useProvideCookieInfo from '@/composable/use-provide-cookie-info';
import useGetCommonMethods from '@/composable/use-get-common-method';
import fetchRecFeeds from '@/services/fetch-rec-feeds';

type FetchReq = {
  dataSource: number,
  feedCount: number,
  playStatus: number,
  attachInfo: string,
};

export default function useRecFeedsMethods() {
  const { state } = useStore();
  const { info: urlInfo } = useProvideUrlInfo();
  const { info: cookieInfo } = useProvideCookieInfo();
  const { getGrowthTestScene } = useGetCommonMethods();

  return (params: FetchReq) => {
    const { dataSource, feedCount, playStatus, attachInfo } = params;
    const { collectionid = '', spid = '', id = '' } = urlInfo.query;
    const curPosterId = state.feedsList?.[state.activeIndex]?.posterId;
    return fetchRecFeeds({
      collectionID: collectionid,
      uniqueID: cookieInfo.openid || cookieInfo.silent_openid,
      feedID: id,
      pageType: collectionid ? 2 : 3,  // 页面类型 0:其他 1:普通播放 2:合集页 3:完播页
      SharerID: spid,
      scene: getGrowthTestScene(),
      hostStatus: spid === curPosterId ? 1 : 0, // 主人状态 0:非主人态 1:主人态
      dataSource,
      feedCount,
      playStatus,
      attachInfo,
    });
  };
}
